document.addEventListener("DOMContentLoaded", function() {
  var lazyImages = [].slice.call(document.querySelectorAll("img.merox-lazy"));

  if ("IntersectionObserver" in window && "IntersectionObserverEntry" in window && "intersectionRatio" in window.IntersectionObserverEntry.prototype) {
    let lazyImageObserver = new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          let lazyImage = entry.target;
          lazyImage.src = lazyImage.dataset.src;
          lazyImage.classList.remove("merox-lazy");
          lazyImageObserver.unobserve(lazyImage);

          // Load the next image in the gallery
          let nextImage = lazyImage.closest('.swiper-slide').nextElementSibling?.querySelector('img.merox-lazy');
          if (nextImage) {
            nextImage.src = nextImage.dataset.src;
            nextImage.classList.remove("merox-lazy");
            lazyImageObserver.unobserve(nextImage); // Optional: if you want to stop observing the next image after loading
          }
        }
      });
    });

    lazyImages.forEach(function(lazyImage) {
      lazyImageObserver.observe(lazyImage);
    });
  }
});

document.addEventListener('DOMContentLoaded', function() {
  var isDesktop = window.matchMedia('(min-width: 1000px) and (hover: hover) and (pointer: fine)').matches;
  var galleries = document.querySelectorAll('.m_grid_gallery');
  galleries.forEach(function(gallery) {
    var dots = gallery.querySelector('.swiper-pagination');
    var swiperOptions = {
      loop: false,
      slidesPerView: 1,
      pagination: {
        el: dots,
        clickable: true,
      },
    };
    if (isDesktop) {
      swiperOptions.effect = 'fade';
      swiperOptions.fadeEffect = { crossFade: true };
    }
    new Swiper(gallery, swiperOptions);
  });
  m_initCollectionHoverGalleries();
});

function m_initCollectionHoverGalleries() {
  if (!window.matchMedia('(min-width: 1000px) and (hover: hover) and (pointer: fine)').matches) return;

  document.querySelectorAll('.m_grid_gallery').forEach(function(gallery) {
    if (gallery.dataset.hoverGalleryBound === 'true') return;

    gallery.dataset.hoverGalleryBound = 'true';

    function attachHoverHandlers() {
      gallery.addEventListener('mouseenter', function() {
        var swiper = gallery.swiper;
        if (!swiper || swiper.slides.length <= 1) return;

        gallery.querySelectorAll('img.merox-lazy').forEach(function(image) {
          if (image.dataset.src) {
            image.src = image.dataset.src;
            image.classList.remove('merox-lazy');
          }
        });

        swiper.slideTo(1, 450);
      });

      gallery.addEventListener('mouseleave', function() {
        var swiper = gallery.swiper;
        if (swiper) {
          swiper.slideTo(0, 450);
        }
      });
    }

    var mouseAlreadyInside = false;
    try { mouseAlreadyInside = gallery.matches(':hover'); } catch (e) {}

    if (mouseAlreadyInside) {
      gallery.addEventListener('mouseleave', function deferredBind() {
        gallery.removeEventListener('mouseleave', deferredBind);
        attachHoverHandlers();
      });
    } else {
      attachHoverHandlers();
    }
  });
}


// COLLECTION LAYOUT SWITCHER
function setLocalStorage(key, value) {
  localStorage.setItem(key, value);
}

function getLocalStorage(key) {
  return localStorage.getItem(key);
}

function initializeLayoutState() {
  const layout = getLocalStorage('layout');
  if (layout == 'single') {
    $('.m-collection-product-list').addClass('m_singleProductLayout');
    $('.singleLayout').addClass('activeLayout');
    $('.defaultLayout').removeClass('activeLayout');
  } else {
    $('.m-collection-product-list').removeClass('m_singleProductLayout');
    $('.defaultLayout').addClass('activeLayout');
    $('.singleLayout').removeClass('activeLayout');
  }
}

$('body').on('click', '.singleLayout', function() {
  $('.m-collection-product-list').addClass('m_singleProductLayout');
  $('.singleLayout').addClass('activeLayout');
  $('.defaultLayout').removeClass('activeLayout');
  setLocalStorage('layout', 'single');
});

$('body').on('click', '.defaultLayout', function() {
  $('.m-collection-product-list').removeClass('m_singleProductLayout');
  $('.defaultLayout').addClass('activeLayout');
  $('.singleLayout').removeClass('activeLayout');
  setLocalStorage('layout', 'default');
});
// END COLLECTION LAYOUT SWITCHER



var templateType = document.querySelector('body').getAttribute('data-template-type');
if (templateType == 'collection') {
  let previousUrl = window.location.href;
  let swiperInstances = [];

  const observer = new MutationObserver(function(mutations) {
    if (window.location.href !== previousUrl) {
      console.log('URL changed');
      previousUrl = window.location.href;
      
      swiperInstances.forEach(instance => instance.destroy(true, true));
      swiperInstances = [];

      var isDesktop = window.matchMedia('(min-width: 1000px) and (hover: hover) and (pointer: fine)').matches;
      var galleries = document.querySelectorAll('.m_grid_gallery');
      galleries.forEach(function(gallery) {
        var dots = gallery.querySelector('.swiper-pagination');
        var swiperOptions = {
          loop: false,
          slidesPerView: 1,
          pagination: {
            el: dots,
            clickable: true,
          },
        };
        if (isDesktop) {
          swiperOptions.effect = 'fade';
          swiperOptions.fadeEffect = { crossFade: true };
        }
        new Swiper(gallery, swiperOptions);
      });
      m_initCollectionHoverGalleries();

      initializeLayoutState();

      var lazyImages = [].slice.call(document.querySelectorAll("img.merox-lazy"));
    
      if ("IntersectionObserver" in window && "IntersectionObserverEntry" in window && "intersectionRatio" in window.IntersectionObserverEntry.prototype) {
        let lazyImageObserver = new IntersectionObserver(function(entries, observer) {
          entries.forEach(function(entry) {
            if (entry.isIntersecting) {
              let lazyImage = entry.target;
              lazyImage.src = lazyImage.dataset.src;
              lazyImage.classList.remove("merox-lazy");
              lazyImageObserver.unobserve(lazyImage);
    
              // Load the next image in the gallery
              let nextImage = lazyImage.closest('.swiper-slide').nextElementSibling?.querySelector('img.merox-lazy');
              if (nextImage) {
                nextImage.src = nextImage.dataset.src;
                nextImage.classList.remove("merox-lazy");
                lazyImageObserver.unobserve(nextImage); // Optional: if you want to stop observing the next image after loading
              }
            }
          });
        });
    
        lazyImages.forEach(function(lazyImage) {
          lazyImageObserver.observe(lazyImage);
        });
      }

    }
  });
  const config = { subtree: true, childList: true };
  observer.observe(document, config);
}


$(document).ready(function() {
  initializeLayoutState();

  $('body').on('click', '.m_swatch', function(e) {
    e.preventDefault();
    console.log('clicked');
    
    var $this = $(this);
    var $parentVariant = $this.parents('.m_metafields_variants');
    var $productCard = $this.closest('.product-card');

    $parentVariant.find('.m_swatch a').removeClass('is-selected');
    $this.find('a').addClass('is-selected');

    var title = $this.data('title');
    var price = $this.data('price');
    var handle = '/products/' + $this.data('handle');
    var images = $this.data('images').split(',');
    var badges = $this.data('badges');
    var id = $this.data('id');

    $productCard.find('.product-card__title a').text(title);
    $productCard.find('.product-card__title a').attr('href', handle);
    $productCard.find('price-list').html(price);
    $productCard.find('.product-card__figure a').attr('href', handle);
    $productCard.find('.m_productBadges').html(badges);

    var galleryHTML = `
      <div class="swiper-container m_grid_gallery m_JSGallery m_JSGallery-${id}">
        <div class="swiper-wrapper"></div>
        <div class="swiper-pagination"></div>
      </div>`;
      
    $productCard.find('.m_defaultGallery, .m_JSGallery').remove();
    $productCard.find('.product-card__figure').append(galleryHTML);

    var $swiperWrapper = $productCard.find('.swiper-wrapper');
    images.forEach(function(image) {
      var slide = `
        <div class="swiper-slide">
          <a href="${handle}">
            <img src="${image}">
          </a>
        </div>`;
      $swiperWrapper.append(slide);
    });

    var isDesktopSwatch = window.matchMedia('(min-width: 1000px) and (hover: hover) and (pointer: fine)').matches;
    var swatchSwiperOptions = {
      loop: false,
      slidesPerView: 1,
      pagination: {
        el: '.m_JSGallery-' + id + ' .swiper-pagination',
        clickable: true,
      },
    };
    if (isDesktopSwatch) {
      swatchSwiperOptions.effect = 'fade';
      swatchSwiperOptions.fadeEffect = { crossFade: true };
    }
    new Swiper('.m_JSGallery-' + id, swatchSwiperOptions);
    m_initCollectionHoverGalleries();
  });



    var $accButtons = $(".mx_mh_london_accordion_button");

  $('body').on("click", ".mx_mh_london_accordion_button", function(e) {
    e.preventDefault();
    var $button = $(this);
    var $content = $button.next(".mx_mh_london_accordion_content");
    var $arrow = $button.find(".arrow");

    if ($content.css("display") === "block") {
      $content.css("display", "none");
      $arrow.removeClass("rotate");
    } else {
      // Close all open accordion content
      $(".mx_mh_london_accordion_content").css("display", "none");
      // Reset all arrows
      $(".arrow").removeClass("rotate");

      $content.css("display", "block");
      $arrow.addClass("rotate");
    }
  });

  // Function to update the quantity input value
  function updateQuantity(input, increment) {
    let currentValue = parseInt(input.value);
    let max = input.getAttribute('max') ? parseInt(input.getAttribute('max')) : Infinity;
    let newValue = currentValue + increment;

    if (newValue < 0 || newValue > max) {
      updateButtonStates(input, newValue, max);
      return;
    }

    input.value = newValue;

    if ($('body[data-template-type="cart"]').length > 0) {
      $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: { id: input.dataset.lineKey, quantity: newValue },
        dataType: 'json',
        success: function() { location.reload(); },
        error: function(err) { console.error('Error updating cart', err); }
      });
      return;
    }

    // Ask all listeners (incl. CartDrawer) which sections they need bundled,
    // then POST with sections so the response carries fresh server-rendered
    // HTML for each. This mirrors the theme's native LineItemQuantity flow.
    let sectionsToBundle = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
      bubbles: true,
      detail: { sections: sectionsToBundle }
    }));

    fetch(`${window.Shopify.routes.root}cart/change.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: input.dataset.lineKey,
        quantity: newValue,
        sections: sectionsToBundle
      })
    })
      .then(function(res) { return res.json(); })
      .then(function(cart) {
        // Dispatching cart:change keeps the theme's fetchCart cache and every
        // <cart-count> in sync, and lets CartDrawer._onCartChanged perform
        // its smart inner replacement using the bundled section HTML.
        document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
          bubbles: true,
          detail: { baseEvent: 'line-item:change', cart: cart }
        }));
        updateButtonStates(input, newValue, max);
      })
      .catch(function(err) { console.error('Error updating cart', err); });
  }

  // Function to update the state of the plus and minus buttons
  function updateButtonStates(input, value, max) {
    let $minusButton = $(input).closest('.m_quantityWrapper').find('.minusButton');
    let $plusButton = $(input).closest('.m_quantityWrapper').find('.plusButton');

    $minusButton.prop('disabled', value <= 0);
    $plusButton.prop('disabled', value >= max);
  }

  // Add event listeners for all plus buttons
  $('body').on('click', '.plusButton', function() {
    let input = $(this).closest('.m_quantityWrapper').find('.quantity-input')[0];
    updateQuantity(input, 1);
  });

  // Add event listeners for all minus buttons
  $('body').on('click', '.minusButton', function() {
    let input = $(this).closest('.m_quantityWrapper').find('.quantity-input')[0];
    updateQuantity(input, -1);
  });

  // Listen for the line-item:change event to perform any additional actions
  document.addEventListener('line-item:change', function(event) {
    let finalQuantity = event.detail.quantity; // New quantity (may be 0 !)
    let lineKey = event.detail.lineKey;
    console.log(`Line item ${lineKey} changed to quantity ${finalQuantity}`);

    // Additional logic if needed
  });

  // Initialize button states on page load
  $('.quantity-input').each(function() {
    let input = this;
    let max = input.getAttribute('max') ? parseInt(input.getAttribute('max')) : Infinity;
    let value = parseInt(input.value);
    updateButtonStates(input, value, max);
  });


  
});


